import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['banner', _vm.color && _vm.color + 'Banner']},[_c(VIcon,{attrs:{"color":_vm.color,"size":_vm.iconSize}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_vm._t("title")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }